import { axios } from '@/utils/request'

export function fetchListPro (params) {
  return axios({
    url: '/attendGroup/page/project',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function fetchListCom (params) {
  return axios({
    url: '/attendGroup/page/company',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/attendGroup/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/attendGroup/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/attendGroup/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/attendGroup/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function dropAttendGroupList () {
  return axios({
    url: `/attendGroup/groupInProjectDropDown`,
    method: 'Get'
  })
}
export function dropAttendGroupListByProjectId (val) {
  return axios({
    url: `/attendGroup/groupInProjectDropDown/` + val,
    method: 'Get'
  })
}

export function attendGroupList () {
  return axios({
    url: `/attendGroup/attendGroupDropDown`,
    method: 'Get'
  })
}
// 查询小组 工人类别 关联 列表
export function getGroupAndWorkerType () {
  return axios({
    url: `/attendGroup/attendGroupAndTypeDropDown`,
    method: 'Get'
  })
}
export function attendProject (params) {
  return axios({
    url: '/projectInfo/dropDown',
    method: 'get',
    params: params
  })
}
